var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classes},[(_vm.variant === 'icon')?_c('logo-icon',{attrs:{"dark":_vm.dark}}):(_vm.variant === 'connect')?_c('logo-connect',{attrs:{"dark":_vm.dark}}):(_vm.variant === 'family')?_c('logo-family',{attrs:{"dark":_vm.dark}}):_c('logo-default',{attrs:{"dark":_vm.dark}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }